import React from 'react';
import moment from 'moment';
import {
    Table,
    TableBody,
    TableRow,
    TableCell
} from '@mui/material';
import { splitWords } from 'utils/helpers';


const Information = (p) => {
    return (
        <div className="content-info">
            <div className="col-lg-12">
                <h4 className="profile-view-subtitle d-block purpleText">General Information</h4>
            </div>
            <div className='row'>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <Table className="table-view-details">
                        <TableBody>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">First Name</TableCell>
                                <TableCell className="table-view-data primary-color-text">{p.firstName}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Last Name</TableCell>
                                <TableCell className="table-view-data primary-color-text">{p.lastName}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">ID</TableCell>
                                <TableCell className="primary-color-text">{p.id}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Role</TableCell>
                                <TableCell className="primary-color-text">{splitWords((p.roleLabel === "StoreOwner" ? "Executive Team" : p.roleLabel) || "")}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">SIN</TableCell>
                                <TableCell className="primary-color-text">{p.sin || ''}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <Table className="table-view-details">
                        <TableBody>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Status</TableCell>
                                <TableCell className="primary-color-text">{p.status == 1 ? "Active" : "Inactive"}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Date of Birth</TableCell>
                                <TableCell className="primary-color-text">{p.birthDate}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Hired Date</TableCell>
                                <TableCell className="primary-color-text">{p.hiredDate ? moment(p.hiredDate).format('YYYY-MM-DD') : ''}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Hourly Rate</TableCell>
                                <TableCell className="primary-color-text">{p.hourlyRate ? `$${p.hourlyRate}` : ''}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            </div>

            {/* Contact Information */}
            <div className="col-lg-12 clear-both pt-3">
                <h4 className="profile-view-subtitle d-block pt-3 purpleText">Contact Information</h4>
            </div>
            <div className='row'>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <Table className="table-view-details">
                        <TableBody>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Address</TableCell>
                                <TableCell className="primary-color-text">{p.address}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">City</TableCell>
                                <TableCell className="primary-color-text">{p.city}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Province</TableCell>
                                <TableCell className="primary-color-text">{p.province}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Postal Code</TableCell>
                                <TableCell className="table-view-data text-uppercase">{p.postalCode}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <Table className="table-view-details">
                        <TableBody>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Country</TableCell>
                                <TableCell className="primary-color-text">{p.country}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Phone</TableCell>
                                <TableCell className="primary-color-text">{p.phone}</TableCell>
                            </TableRow>
                            <TableRow className="table-view-info">
                                <TableCell className="table-view-title primary-color-text">Email</TableCell>
                                <TableCell className="view-email primary-color-text">{p.email}</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </div>
            </div>

        </div>
    )
}

export default Information;